function positionModelSizeNote(note) {
  const media = note.closest('.product-media');
  const image = media?.querySelector('.product-media__image');

  if (!media || !image || !image.naturalWidth || !image.naturalHeight) return;

  const boxWidth = image.clientWidth;
  const boxHeight = image.clientHeight;
  const imageRatio = image.naturalWidth / image.naturalHeight;
  const boxRatio = boxWidth / boxHeight;
  const insetX = boxRatio > imageRatio ? (boxWidth - boxHeight * imageRatio) / 2 : 0;
  const insetY = boxRatio < imageRatio ? (boxHeight - boxWidth / imageRatio) / 2 : 0;

  note.style.setProperty('--atl-image-inset-x', `${Math.max(0, insetX)}px`);
  note.style.setProperty('--atl-image-inset-y', `${Math.max(0, insetY)}px`);
}

function initialiseModelSizeNotes() {
  document.querySelectorAll('.atl-model-size').forEach((note) => {
    const image = note.closest('.product-media')?.querySelector('.product-media__image');
    const update = () => positionModelSizeNote(note);

    if (image?.complete) update();
    else image?.addEventListener('load', update, { once: true });

    new ResizeObserver(update).observe(note.closest('.product-media'));
  });
}

initialiseModelSizeNotes();
